import React from 'react'

import { TextLink, UiArrowRightIcon } from '@octane/spark'
import {
    CollateralResponse,
    PowersportsAssetResponse,
} from 'api/application/getCollaterals'
import Card from 'components/Card'
import { formatCurrency } from 'utils/formatCurrency'
import getAssetValuationMethod from 'utils/getAssetValuationMethod'
import getVehicleTypeIcon, { VehicleType } from 'utils/getVehicleTypeIcon'

import {
    CollateralField,
    CollateralInfo,
    DetailContainer,
    DetailInfo,
    DetailLabel,
    HeaderField,
    RuleLine,
    TextWrapper,
} from './DecisionResult.styled'

export default function DecisionResultCollateralCard({
    applicationId,
    collaterals,
}: {
    readonly applicationId: number
    readonly collaterals: CollateralResponse<PowersportsAssetResponse>[]
}): JSX.Element {
    const vehicleCondition = (condition: string) => {
        return condition === 'N' ? 'New' : 'Used'
    }

    const handleClickSubmitDifferent = () => {
        window.location.href = `#/copy-vehicle/${applicationId}/`
    }

    const isMultiUnit = collaterals.length > 1

    return (
        <Card style={{ padding: '20px' }}>
            <DetailContainer>
                <div>
                    <HeaderField>
                        <div>{`Collateral${isMultiUnit ? 's' : ''}`}</div>
                        <DetailInfo>
                            <TextLink
                                onClick={handleClickSubmitDifferent}
                                variant="simple"
                            >
                                Submit Different Vehicle <UiArrowRightIcon />
                            </TextLink>
                        </DetailInfo>
                    </HeaderField>
                    <RuleLine />
                    {collaterals.map(
                        (
                            collateral: CollateralResponse<PowersportsAssetResponse>,
                            index: number,
                        ) => {
                            const VehicleIcon = getVehicleTypeIcon(
                                collateral.asset.vehicle_type as VehicleType,
                            )

                            const assetValuationMethod =
                                getAssetValuationMethod(collateral)

                            return (
                                <CollateralField
                                    key={collateral.id}
                                    data-testid="collateral-item"
                                >
                                    <div>
                                        <VehicleIcon />
                                    </div>
                                    <CollateralInfo>
                                        <div>
                                            <DetailLabel>
                                                {`Vehicle ${
                                                    isMultiUnit ? index + 1 : ''
                                                }`}
                                            </DetailLabel>
                                            <div style={{ fontWeight: '700' }}>
                                                {`${vehicleCondition(
                                                    collateral.asset.condition,
                                                )} ${collateral.asset_name}`}
                                            </div>
                                        </div>
                                    </CollateralInfo>
                                    <CollateralInfo
                                        style={{ marginTop: '16px' }}
                                    >
                                        <TextWrapper>
                                            {formatCurrency(
                                                Number(collateral.asset_value),
                                            )}
                                        </TextWrapper>
                                        <TextWrapper>
                                            {assetValuationMethod}
                                        </TextWrapper>
                                    </CollateralInfo>
                                </CollateralField>
                            )
                        },
                    )}
                </div>
            </DetailContainer>
        </Card>
    )
}
